module.exports = __webpack_public_path__ + "img/copy_whatsapp_script_icon.c211cffc.svg";